var Accordion;
(function (Accordion) {
    myonce('accordion', () => {
        const accordion = document.querySelectorAll('.accordion-collapse');
        if (accordion.length) {
            accordion.forEach((element) => {
                let container = element.querySelector('.container-accordion');
                let arrow = element.querySelector('.image-accordion');
                let labelClose = element.querySelector('.label-open');
                let labelOpen = element.querySelector('.label-close');
                let button = element.querySelector('.button-accordion');
                if (button) {
                    button.addEventListener('click', () => {
                        container.classList.toggle('open');
                        if (arrow) {
                            arrow.classList.toggle('rotate-arrow-180');
                        }
                        if (labelClose) {
                            labelClose.classList.toggle('active');
                        }
                        if (labelOpen) {
                            labelOpen.classList.toggle('active');
                        }
                    });
                }
            });
        }
    });
})(Accordion || (Accordion = {}));
